export interface DocumentSignatureFlowNode {
    id: number;
    order: number;
    functie_id: number;
    functie_name: string;
    sign_type: number;
    directie_id: number | null;
    directie_name: string | null;
    compartiment_id: number | null;
    compartiment_name: string | null;
    user_id: number | null;
    user_name: string | null;
    specific_user_id: number | null;
    specific_user_name: string | null;
    action_date: string | null;
    type: number; // 0=pending, 1=signed, 2=rejected
    observations: string | null;
}

export interface DocumentSignatureFlowData {
    document_generat_id: number;
    document_registratura_id: number;
    reg_number: string | null;
    reg_date: string | null;
    template_id: number;
    template_name: string;
    template_directie_name: string | null;
    template_compartiment_name: string | null;
    is_dual: boolean;
    operator_name: string | null;
    current_user_name: string | null;
    exemplar_complet: DocumentSignatureFlowNode[];
    exemplar_cetatean: DocumentSignatureFlowNode[];
    generated_at: string;
}

export const SIGNATURE_TYPES: { [key: number]: { icon: string; label: string; class: string } } = {
    1: { icon: 'edit', label: 'Semnare', class: 'sign-type-semnare' },
    2: { icon: 'check_circle', label: 'Aprobare', class: 'sign-type-aprobare' },
    3: { icon: 'verified', label: 'Confirmare', class: 'sign-type-confirmare' },
    4: { icon: 'draw', label: 'Semnare Olografică', class: 'sign-type-olografica' }
};

export const VALIDATION_STATUSES: { [key: number]: { label: string; class: string; icon: string } } = {
    0: { label: 'În așteptare', class: 'status-pending', icon: 'schedule' },
    1: { label: 'Semnat', class: 'status-signed', icon: 'check_circle' },
    2: { label: 'Respins', class: 'status-rejected', icon: 'cancel' }
};
